import { useSelector } from "react-redux";
import moment from "moment";

import { onDtStartChange, onDtEndChange, getWorkorderItemsRedux, onClearWorkorders } from "../../redux/slices/workorderItems.feature";
import { useEffect } from "react";
import { onSetSelectedWorkorders } from "../../redux/slices/workorderItems.feature";
import { useAppDispatch } from "../../redux/hooks";
import { IRootState } from "../../types/redux/IRootStore";
import { useTranslation } from "react-i18next";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { useParams } from "react-router-dom";
import DateSelector3 from "../common/DateSelector3";

export default function WorkorderManagementSearch(props: {
    showClosed: boolean;
    workorderSearchString: string;
    setWorkorderSearchString: (value: string) => void;
    setShowClosed: (value: boolean) => void;
}) {
    const { t } = useTranslation();
    const aplSettings = AplSettingsSelector();
    const dispatch = useAppDispatch();

    const workorderItemsState = useSelector((state: IRootState) => state.workorderItems);
    const params = useParams();
    const lineId = params["lineId"] ? Number(params["lineId"]) : 0;

    // const searchByDateOrWorkorder = (bClosed: boolean, workorder: string) => {
    //     dispatch(
    //         getWorkorderItems({
    //             siteId: aplSettings.siteId,
    //             departmentId: aplSettings.departmentId,
    //             lineId: params["lineId"] ? Number(params["lineId"]) : 0,
    //             start: workorderItemsState.dateStartSelectorDate,
    //             end: workorderItemsState.dateEndSelectorDate,
    //             closed: bClosed,
    //             workorder: workorder
    //         }) as any
    //     );
    // };

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };

    const onSearch = () => {
        dispatch(onSetSelectedWorkorders([]));
        dispatch(getWorkorderItemsRedux(lineId) as any);
    };

    useEffect(() => {
        dispatch(onClearWorkorders(undefined));
        return onSearch();
    }, [aplSettings.departmentId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="float-right">
            <div className="input-group mb-3">
                <div className="custom-control custom-switch float-right bs-switch margin-top03em ml-3 mr-3">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="swClosed"
                        onChange={e => {
                            props.setShowClosed(e.target.checked);
                            onSearch();
                        }}
                        checked={props.showClosed}
                    />
                    <label className="custom-control-label" htmlFor="swClosed" id="lblSwClosed">
                        {t("main.woSClosed")}
                    </label>
                </div>

                <DateSelector3
                    name="date-input-start"
                    onSetSelectedDate={(x: Date | null) => {
                        dispatch(onDtStartChange(x));
                    }}
                    selectedDate={moment(workorderItemsState.dateStartSelectorDate).toDate()}
                    culture={aplSettings.culture}
                    small={true}
                />

                <DateSelector3
                    name="date-input-end"
                    onSetSelectedDate={(e: Date | null) => {
                        dispatch(onDtEndChange(e));
                    }}
                    selectedDate={moment(workorderItemsState.dateEndSelectorDate).toDate()}
                    culture={aplSettings.culture}
                    small={true}
                />

                <input
                    type="text"
                    id="txtWorkorder"
                    className="form-control form-control-sm"
                    placeholder={t("main.workOrder") ?? "Workorder"}
                    aria-label="Date Start"
                    aria-describedby="date-start"
                    value={props.workorderSearchString}
                    onChange={e => {
                        props.setWorkorderSearchString(e.target.value);
                    }}
                    onKeyDown={handleKeyDown}
                />
                <div className="input-group-append">
                    <button
                        id="btnSearchWorkorder"
                        className="btn btn-sm btn-primary"
                        type="button"
                        onClick={() => {
                            onSearch();
                        }}
                    >
                        {t("main.search")}
                    </button>
                </div>
            </div>
        </div>
    );
}
